import { call, put, takeEvery, delay } from 'redux-saga/effects'

import { onSubscribePush, setNotificationsPending, onSetSubscriptionState } from '../actions'
import { getSubscriptionState } from './onGetSubscriptionState'

export function* handleSubscribe() {
  let OneSignal = window.OneSignal
  try {
    yield put(setNotificationsPending())
    let waiting = 0
    while (!OneSignal) {
      OneSignal = window.OneSignal
      if (waiting > 10000) {
        throw new Error(`Exit wait timeout. Waited ${waiting} milliseconds`)
      }
      waiting += 200
      yield delay(200)
    }

    const { isPushEnabled, isOptedOut } = yield call(getSubscriptionState, OneSignal)
    if (isPushEnabled) {
      /* Subscribed, opt them out */
      yield call(OneSignal.setSubscription, false)
      yield put(
        onSetSubscriptionState({
          isPushEnabled: false,
          isOptedOut: true,
        })
      )
    } else {
      if (isOptedOut) {
        /* Opted out, opt them back in */
        yield call(OneSignal.setSubscription, true)
        yield put(
          onSetSubscriptionState({
            isPushEnabled: true,
            isOptedOut: false,
          })
        )
      } else {
        /* Unsubscribed, subscribe them */
        yield call(OneSignal.registerForPushNotifications)
      }
    }
    yield put(setNotificationsPending(false))
  } catch (e) {
    yield put(setNotificationsPending(false))
    console.log('handleGetSubscription FAIL', e)
  }
}

export default function* handleSubscribeTakeEvery() {
  yield takeEvery(onSubscribePush.toString(), handleSubscribe)
}
